import store from "@/store";

const userPages: any = {
  admin: "/application_requests",
  guest: "/application",
  operator: "/application_requests",
};
const credentials = store.getters["authentication/credentials"];

export default [
  {
    path: `/`,
    redirect: credentials.user
      ? userPages[credentials.user.position]
      : "/auth/login",
  },
];
